import { Col, Container, Row } from "reactstrap";
import { EidDetails, NestDetails, PassportDetails } from "./nestEiddetails";
import React, { useEffect, useState } from "react";
import {
  RegistrationVerificationDetails,
  RegistrationVerificationEidUrl,
  RejectEidUrl,
  RejectionListDetails,
} from "../../../service/user-verification-service";
import { useHistory, useLocation } from "react-router-dom";
import AppRegistrationDetails from "./appRegistrationDetails";
import Comments from "./comments";
import EidFront from "./eidfront";
import NkHeader from "../../../common/nkheader";
import RegistraionHeader from "./registrationheader";

const RegistrationVerification = () => {
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [registrationObject, setRegistrationObject] = useState({
    nestDetails: {
      fullName: null,
      nationality: null,
      dateOfBirth: null,
      passportNumber: null,
      company: null,
      cardStatus: null,
    },
    emiratesIdDetails: {
      fullName: null,
      nationality: null,
      dateOfBirth: null,
      emiratesIdNumber: null,
      expiryDate: null,
      cardNumber: null,
      gender: null,
    },
    registrationDetails: {
      registrationDate: null,
      cardNumber: null,
      phoneNumber: null,
      email: null,
    },
    emiratesIdUpdateId: null,
    emiratesIdUpdateStatus: null,
    nameMatchPercentage: 0,
    isIdealNameMatchPercentage: true,
    faceMatchPercentage: 0,
    isIdealFaceMatchPercentage: true,
  });

  const { state } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (state && state.id) {
      if (registrationType === "NoKYC" && state.title === "Verifications") {
        getUserVerificationDetailById(state.id);
      }

      if (registrationType !== "NoKYC" && state.title === "Verifications") {
        getUploadImageUrl(state.id);
        getUserVerificationDetailById(state.id);
      }
      if (registrationType !== "NoKYC" && state.title === "Rejected User") {
        getRejectUploadImageUrl(state.id);
        getUserRejectionDetailById(state.id);
      }
    } else {
      history.push("/admin");
    }
  }, []);

  const [images, setImages] = useState({
    frontEIDImageURL: null,
    backEIDImageURL: null,
    selfieImageURL: null,
    passportImageURL: null,
  });
  const [apiimages, setApiImages] = useState({
    frontEIDImageURL: null,
    backEIDImageURL: null,
    selfieImageURL: null,
    passportImageURL: null,
  });

  const getUploadImageUrl = (id) => {
    setVerificationLoading(true);
    RegistrationVerificationEidUrl(id)
      .then((res) => {
        if (res && res.data) {
          setImages({ ...images, ...res.data });
        }
        setVerificationLoading(false);
      })
      .catch((err) => {
        setVerificationLoading(false);
        console.log(err);
      });
  };
  const getRejectUploadImageUrl = (id) => {
    setVerificationLoading(true);
    RejectEidUrl(id)
      .then((res) => {
        if (res && res.data) {
          setImages({ ...images, ...res.data });
        }
        setVerificationLoading(false);
      })
      .catch((err) => {
        setVerificationLoading(false);
        console.log(err);
      });
  };

  const getUserVerificationDetailById = (id) => {
    setVerificationLoading(true);
    RegistrationVerificationDetails(id)
      .then((res) => {
        setVerificationLoading(false);
        if (res && res.data) {
          setRegistrationObject(res.data);
        }
      })
      .catch((err) => {
        setVerificationLoading(false);
        console.log(err);
      });
  };
  const getUserRejectionDetailById = (id) => {
    setVerificationLoading(true);
    RejectionListDetails(id)
      .then((res) => {
        setVerificationLoading(false);
        if (res && res.data) {
          setRegistrationObject(res.data);
        }
      })
      .catch((err) => {
        setVerificationLoading(false);
        console.log(err);
      });
  };

  const [isremove, setIsRemove] = useState(false);
  const [registrationType, setRegistrationType] = useState(
    state && state.registrationType ? state.registrationType : null
  );

  return (
    <>
      <Container fluid>
        <NkHeader title={state.title} />

        <Row className="card-wrapper">
          <Col lg="12">
            <RegistraionHeader
              registrationObject={registrationObject}
              title={state.title}
              registrationType={registrationType}
            />
          </Col>
        </Row>
        <Row className="card-wrapper" style={{ display: "flex" }}>
          <Col lg="8">
            <Row className="card-wrapper">
              <Col lg="12" className="reg-card-parent">
                <Row>
                  <Col
                    lg="6"
                    className="eid-reg"
                    style={{ paddingRight: "5px", paddingLeft: 0 }}
                  >
                    <NestDetails
                      registrationObject={registrationObject.nestDetails}
                      id={state && state.id}
                      verificationLoading={verificationLoading}
                      title={state.title}
                      rejectReason={registrationObject.rejectReason}
                    />
                  </Col>
                  {(state.type === "EmiratesId" || state.type === "EID") && (
                    <Col
                      className="eid-reg"
                      lg="6"
                      style={{ paddingRight: "10px", paddingLeft: "5px" }}
                    >
                      <EidDetails
                        registrationEidDetails={
                          registrationObject.emiratesIdDetails
                        }
                        verificationLoading={verificationLoading}
                      />
                    </Col>
                  )}

                  {state.type === "Passport" && (
                    <Col
                      className="eid-reg"
                      lg="6"
                      style={{ paddingRight: "10px", paddingLeft: "5px" }}
                    >
                      <PassportDetails
                        passportDetails={registrationObject.passportDetails}
                        verificationLoading={verificationLoading}
                      />
                    </Col>
                  )}
                </Row>
              </Col>
              <Col lg="12" style={{ paddingRight: "10px", paddingLeft: 0 }}>
                <AppRegistrationDetails
                  registrationAppDetails={
                    registrationObject.registrationDetails
                  }
                  verificationLoading={verificationLoading}
                />
                <Comments id={state && state.id} style={{ height: 250 }} />
              </Col>
            </Row>
          </Col>
          <Col lg="4" style={{ paddingRight: "10px", paddingLeft: "0px" }}>
            {!apiimages.passportImageURL && (
              <EidFront
                isremove={isremove}
                title={state.title}
                registrationType={registrationType}
                imageSRC={images && images.frontEIDImageURL}
                content={"FRONT OF EID HERE"}
                setisRemove={setIsRemove}
                uploadCall={(file, url) => {
                  setImages({ ...images, frontEIDImageURL: url });
                  setApiImages({ ...apiimages, frontEIDImageURL: file });
                }}
              />
            )}
            {!apiimages.passportImageURL && (
              <EidFront
                isremove={isremove}
                title={state.title}
                registrationType={registrationType}
                setisRemove={setIsRemove}
                imageSRC={images && images.backEIDImageURL}
                content={"BACK OF EID HERE"}
                uploadCall={(file, url) => {
                  setImages({ ...images, backEIDImageURL: url });
                  setApiImages({ ...apiimages, backEIDImageURL: file });
                }}
              />
            )}

            <EidFront
              isremove={isremove}
              title={state.title}
              registrationType={registrationType}
              setisRemove={setIsRemove}
              imageSRC={images && images.selfieImageURL}
              content="SELFIE HERE"
              uploadCall={(file, url) => {
                setImages({ ...images, selfieImageURL: url });
                setApiImages({ ...apiimages, selfieImageURL: file });
              }}
            />
            {!apiimages.frontEIDImageURL && !apiimages.backEIDImageURL && (
              <EidFront
                isremove={isremove}
                title={state.title}
                setisRemove={setIsRemove}
                registrationType={registrationType}
                imageSRC={images && images.passportImageURL}
                content="PASSPORT HERE"
                uploadCall={(file, url) => {
                  setImages({ ...images, passportImageURL: url });
                  setApiImages({ ...apiimages, passportImageURL: file });
                }}
              />
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RegistrationVerification;
